import { Tag } from "antd";

import { Status, statusToColor } from "./utils";

export interface StatusTagProps {
  status: Status;
}

const StatusTag = ({ status }: StatusTagProps) => (
  <Tag color={statusToColor(status)}>{status}</Tag>
);

export default StatusTag;
